/**
 * GoldN mid-funnel web-pixel bridge (AddToCart / InitiateCheckout).
 *
 * Canonical Meta **dataset** stays 8586067024852602 (Shopify Facebook
 * channel + Customer Events row 1115750678). This file does not init a
 * pixel, change that dataset, or emit Purchase.
 *
 * 2026-09-14 console (w2 LIVE, authoritative):
 * - GoldNMetaFunnel present; fbq=function; WPM present
 * - After ATC + Checkout: 0 facebook.com/tr requests
 * - fbq('set','userData') with pixel_id "8586067024852602" → INVALID
 *   (dataset ID is not a classic Facebook Pixel ID)
 * - "You are attempting to send a restricted event. The event was suppressed."
 * - Funnel payloads had no test_event_code (TEST97112)
 *
 * w3:
 * - Capture WPM standard publish() more reliably (init intercept + poll)
 * - fbq track ONLY if a valid classic pixel id is already inited
 *   (from fbq.queue / pixelsByID). Never pass the dataset ID as pixel_id.
 * - Optional ?meta_test_event_code=TEST… / localStorage / Meta test cookie
 * - Optional ?goldn_meta_debug=1 logs capture + publish (off in production)
 */
(function (root) {
  if (root.__goldnMetaFunnel) return;
  root.__goldnMetaFunnel = true;

  var DEDUPE_MS = 2500;
  var FBQ_RETRY_MS = 400;
  var FBQ_RETRY_MAX = 6;
  var WPM_POLL_MS = 50;
  var WPM_POLL_MAX = 40;
  var DATASET_ID = '8586067024852602';
  var SHOPIFY_FB_ROW_ID = '1115750678';
  var recent = Object.create(null);
  var lastCart = null;
  var lastItems = [];
  var standardPublish = null;
  var pendingStandard = [];
  var wpmHeld;
  var wpmPolls = 0;
  var lastError = null;
  var lastPublish = null;
  var lastFbq = null;

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function seen(key) {
    var t = now();
    if (recent[key] && t - recent[key] < DEDUPE_MS) return true;
    recent[key] = t;
    return false;
  }

  function noteError(where, err) {
    lastError = {
      where: where,
      message: err && err.message ? String(err.message) : String(err || 'unknown'),
      at: now(),
    };
    log('error', where, lastError.message);
  }

  function flagOn(queryKey, storeKey) {
    try {
      var params = new URLSearchParams(root.location.search);
      var q = params.get(queryKey);
      if (q === '1' || q === 'true') {
        try {
          root.sessionStorage.setItem(storeKey, '1');
        } catch (e) {}
        return true;
      }
      if (q === '0' || q === 'false') {
        try {
          root.sessionStorage.removeItem(storeKey);
        } catch (e) {}
        return false;
      }
      return root.sessionStorage.getItem(storeKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function debugEnabled() {
    return flagOn('goldn_meta_debug', 'goldn_meta_debug');
  }

  function log() {
    if (!debugEnabled()) return;
    try {
      var args = ['[GoldNMetaFunnel]'];
      for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
      if (typeof console !== 'undefined' && console.info) console.info.apply(console, args);
    } catch (e) {}
  }

  function readTestEventCode() {
    try {
      var params = new URLSearchParams(root.location.search);
      var fromQuery = params.get('meta_test_event_code');
      if (fromQuery && /^TEST[A-Z0-9]+$/i.test(fromQuery)) {
        var normalized = fromQuery.toUpperCase();
        try {
          root.localStorage.setItem('meta_test_event_code', normalized);
        } catch (e) {}
        return normalized;
      }
      var stored = root.localStorage.getItem('meta_test_event_code');
      if (stored && /^TEST[A-Z0-9]+$/i.test(stored)) return stored.toUpperCase();
      var cookie = document.cookie || '';
      var parts = cookie.split(';');
      var names = {
        _fbq_set_test_event_code: 1,
        test_event_code: 1,
        _fbq_test_event_code: 1,
      };
      for (var i = 0; i < parts.length; i++) {
        var row = parts[i].trim();
        var eq = row.indexOf('=');
        if (eq < 1) continue;
        var name = row.slice(0, eq);
        if (!names[name]) continue;
        var val = decodeURIComponent(row.slice(eq + 1));
        if (/^TEST[A-Z0-9]+$/i.test(val)) return val.toUpperCase();
      }
    } catch (e) {}
    return '';
  }

  function looksLikeClassicPixelId(id) {
    var s = String(id || '');
    if (!/^\d{5,16}$/.test(s)) return false;
    if (s === DATASET_ID) return false;
    if (s === SHOPIFY_FB_ROW_ID) return false;
    return true;
  }

  function addPixelId(ids, seenMap, raw) {
    var s = String(raw || '');
    if (!looksLikeClassicPixelId(s) || seenMap[s]) return;
    seenMap[s] = true;
    ids.push(s);
  }

  function loadedFbqPixelIds() {
    var ids = [];
    var seenMap = Object.create(null);
    try {
      var fbq = root.fbq;
      if (typeof fbq !== 'function') return ids;
      var queue = fbq.queue;
      if (queue && queue.length) {
        for (var i = 0; i < queue.length; i++) {
          var item = queue[i];
          if (item && item[0] === 'init' && item[1] != null) addPixelId(ids, seenMap, item[1]);
        }
      }
      var inst = fbq.instance || (root._fbq && root._fbq.instance);
      if (inst) {
        var byId = inst.pixelsByID || inst.pixelsById;
        if (byId) {
          var keys = Object.keys(byId);
          for (var k = 0; k < keys.length; k++) addPixelId(ids, seenMap, keys[k]);
        }
        if (inst.pixels && inst.pixels.length) {
          for (var p = 0; p < inst.pixels.length; p++) {
            if (inst.pixels[p] && inst.pixels[p].id != null) addPixelId(ids, seenMap, inst.pixels[p].id);
          }
        }
      }
      if (fbq.loadedPixels && fbq.loadedPixels.length) {
        for (var l = 0; l < fbq.loadedPixels.length; l++) {
          var loaded = fbq.loadedPixels[l];
          addPixelId(ids, seenMap, loaded && loaded.id != null ? loaded.id : loaded);
        }
      }
    } catch (e) {
      noteError('loadedFbqPixelIds', e);
    }
    return ids;
  }

  function currencyCode() {
    var shopify = root.Shopify || {};
    var currency = shopify.currency || {};
    if (currency.active) return String(currency.active);
    var meta = root.ShopifyAnalytics && root.ShopifyAnalytics.meta;
    if (meta && meta.currency) return String(meta.currency);
    return 'USD';
  }

  function dollars(centsOrPrice) {
    var n = Number(centsOrPrice);
    if (!isFinite(n)) return 0;
    if (n > 0 && n < 1000 && String(centsOrPrice).indexOf('.') !== -1) return n;
    return n / 100;
  }

  function itemDollars(item) {
    if (!item) return 0;
    if (item.presentment_price != null && item.presentment_price !== '') {
      var presentment = Number(item.presentment_price);
      if (isFinite(presentment)) return presentment;
    }
    if (item.final_price != null) return dollars(item.final_price);
    if (item.price != null) return dollars(item.price);
    return 0;
  }

  function variantIdOf(item) {
    if (!item) return '';
    var raw = item.variant_id || item.id;
    if (raw == null) return '';
    return String(raw).replace(/\D/g, '') || String(raw);
  }

  function productIdOf(item) {
    if (!item || item.product_id == null) return '';
    return String(item.product_id).replace(/\D/g, '') || String(item.product_id);
  }

  function imageSrcOf(item) {
    if (!item) return '';
    if (typeof item.image === 'string') return item.image;
    if (item.image && typeof item.image.src === 'string') return item.image.src;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return '';
  }

  function cartToken() {
    try {
      var match = document.cookie.match(/(?:^|; )cart=([^;]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function cartUrl() {
    return ((root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/') + 'cart.js';
  }

  function rememberCart(cart) {
    if (cart && typeof cart === 'object' && !cart.status) lastCart = cart;
  }

  function rememberItems(items) {
    if (items && items.length) lastItems = items;
  }

  function setStandardPublish(fn) {
    if (typeof fn !== 'function') return;
    if (standardPublish === fn) return;
    standardPublish = fn;
    log('standardPublish captured');
    while (pendingStandard.length) {
      var job = pendingStandard.shift();
      invokeStandard(job.name, job.payload);
    }
  }

  function hookManager(manager) {
    if (manager && typeof manager.publish === 'function') {
      setStandardPublish(manager.publish.bind(manager));
    }
  }

  function wrapInitFn(fn) {
    if (typeof fn !== 'function') return fn;
    if (fn.__goldnWrapped) return fn;
    var wrapped = function () {
      var manager = fn.apply(this, arguments);
      try {
        hookManager(manager);
        if (this && manager) this.__goldnManager = manager;
      } catch (e) {
        noteError('hookManager', e);
      }
      return manager;
    };
    wrapped.__goldnWrapped = true;
    return wrapped;
  }

  function interceptInit(wpm) {
    if (!wpm || typeof wpm !== 'object') return;
    var currentInit = typeof wpm.init === 'function' ? wpm.init : null;
    if (currentInit && currentInit.__goldnWrapped && wpm.__goldnInitIntercept) return;
    try {
      Object.defineProperty(wpm, 'init', {
        configurable: true,
        enumerable: true,
        get: function () {
          return currentInit ? wrapInitFn(currentInit) : currentInit;
        },
        set: function (fn) {
          currentInit = fn;
          log('webPixelsManager.init assigned');
        },
      });
      wpm.__goldnInitIntercept = true;
    } catch (e) {
      if (currentInit && !currentInit.__goldnWrapped) {
        try {
          wpm.init = wrapInitFn(currentInit);
        } catch (err) {
          noteError('interceptInit', err);
        }
      }
    }
  }

  function scanForManager(obj, depth) {
    if (!obj || typeof obj !== 'object' || depth > 2) return;
    try {
      if (typeof obj.publish === 'function' && typeof obj.publishCustomEvent === 'function') {
        hookManager(obj);
        return;
      }
      var keys = ['__goldnManager', 'manager', '_manager', 'instance', 'api'];
      for (var i = 0; i < keys.length; i++) {
        if (obj[keys[i]]) scanForManager(obj[keys[i]], depth + 1);
      }
    } catch (e) {}
  }

  function wrapWpmInit(wpm) {
    if (!wpm || typeof wpm !== 'object') return;
    interceptInit(wpm);
    scanForManager(wpm, 0);
    wpm.__goldnHooked = true;
  }

  function installWpmHook() {
    wrapWpmInit(root.webPixelsManager);
    try {
      if (wpmHeld) return;
      var current = root.webPixelsManager;
      Object.defineProperty(root, 'webPixelsManager', {
        configurable: true,
        enumerable: true,
        get: function () {
          return current;
        },
        set: function (value) {
          current = value;
          log('webPixelsManager object assigned');
          wrapWpmInit(value);
        },
      });
      wpmHeld = true;
      if (current) wrapWpmInit(current);
    } catch (e) {
      noteError('installWpmHook', e);
      wrapWpmInit(root.webPixelsManager);
    }
  }

  function pollWpm() {
    wrapWpmInit(root.webPixelsManager);
    if (standardPublish || wpmPolls >= WPM_POLL_MAX) {
      log('wpm poll done', { captured: !!standardPublish, polls: wpmPolls });
      return;
    }
    wpmPolls += 1;
    setTimeout(pollWpm, WPM_POLL_MS);
  }

  function invokeStandard(name, payload) {
    try {
      var result = standardPublish(name, payload);
      lastPublish = { name: name, ok: true, result: result == null ? true : result, at: now() };
      log('standard publish', name, lastPublish.result);
      return result;
    } catch (e) {
      lastPublish = { name: name, ok: false, error: String(e && e.message ? e.message : e), at: now() };
      noteError('publishStandard:' + name, e);
    }
  }

  function publishStandard(name, payload) {
    if (standardPublish) {
      invokeStandard(name, payload);
      return;
    }
    pendingStandard.push({ name: name, payload: payload });
    if (pendingStandard.length > 8) pendingStandard.shift();
    log('standard publish queued', name, 'pending=', pendingStandard.length);
    wrapWpmInit(root.webPixelsManager);
  }

  function fbqTrack(eventName, params, retryKey) {
    try {
      if (typeof root.fbq === 'function') {
        var ids = loadedFbqPixelIds();
        if (!ids.length) {
          lastFbq = {
            eventName: eventName,
            skipped: true,
            reason: 'no_valid_classic_pixel_id',
            datasetIdNotUsed: DATASET_ID,
            at: now(),
          };
          log('skip fbq; no valid classic pixel id (will not use dataset', DATASET_ID, ')');
          return;
        }
        var payload = params ? Object.assign({}, params) : {};
        var testCode = readTestEventCode();
        var eventData = {};
        if (testCode) {
          payload.test_event_code = testCode;
          eventData.testEventCode = testCode;
        }
        for (var i = 0; i < ids.length; i++) {
          if (eventData.testEventCode) {
            root.fbq('trackSingle', ids[i], eventName, payload, eventData);
          } else {
            root.fbq('trackSingle', ids[i], eventName, payload);
          }
        }
        lastFbq = { eventName: eventName, skipped: false, pixelIds: ids, at: now() };
        log('fbq trackSingle', eventName, ids);
        return;
      }
    } catch (e) {
      lastFbq = { eventName: eventName, skipped: true, reason: 'error', at: now() };
      noteError('fbqTrack:' + eventName, e);
      return;
    }
    if (!retryKey || recent[retryKey] > FBQ_RETRY_MAX) return;
    recent[retryKey] = (recent[retryKey] || 0) + 1;
    setTimeout(function () {
      fbqTrack(eventName, params, retryKey);
    }, FBQ_RETRY_MS);
  }

  function trekkieTrack(name, properties) {
    try {
      var lib = root.ShopifyAnalytics && root.ShopifyAnalytics.lib;
      if (!lib || typeof lib.track !== 'function') return;
      lib.track(name, properties, undefined, undefined, {
        addApiSource: 'goldn-meta-funnel',
        shopifyEmitted: true,
      });
    } catch (e) {
      noteError('trekkieTrack:' + name, e);
    }
  }

  function lineItemsFromAddResponse(json) {
    if (!json || typeof json !== 'object') return [];
    if (json.status) return [];
    if (Array.isArray(json.items) && json.items.length) return json.items;
    if (json.variant_id || json.product_id || json.id) return [json];
    return [];
  }

  function publishProductAdded(item) {
    var variantId = variantIdOf(item);
    if (!variantId) return;
    if (seen('atc:' + variantId)) return;

    var qty = parseInt(item.quantity, 10);
    if (!qty || qty < 1) qty = 1;
    var amount = itemDollars(item);
    var currency = currencyCode();
    var productId = productIdOf(item);
    var title = item.product_title || item.title || '';
    var variantTitle = item.variant_title || '';
    var imageSrc = imageSrcOf(item);
    var value = amount * qty;

    // v1 storefront schema uses numeric string IDs (same as live product_viewed).
    publishStandard('product_added_to_cart', {
      cartLine: {
        quantity: qty,
        cost: {
          totalAmount: { amount: value, currencyCode: currency },
        },
        merchandise: {
          id: variantId,
          image: { src: imageSrc },
          price: { amount: amount, currencyCode: currency },
          product: {
            id: productId,
            title: title,
            type: item.product_type || null,
            untranslatedTitle: title,
            url: item.url || null,
            vendor: item.vendor || '',
          },
          sku: item.sku || null,
          title: variantTitle,
          untranslatedTitle: variantTitle,
        },
      },
    });

    trekkieTrack('Added Product', {
      variantId: variantId,
      productId: productId,
      currency: currency,
      quantity: String(qty),
      price: amount,
      name: title,
      sku: item.sku || '',
      brand: item.vendor || '',
      variant: variantTitle,
      category: item.product_type || '',
      cartToken: cartToken() || undefined,
    });

    fbqTrack(
      'AddToCart',
      {
        content_ids: [variantId],
        content_type: 'product',
        content_name: title,
        content_category: item.product_type || undefined,
        value: value,
        currency: currency,
      },
      'fbq:atc:' + variantId
    );
  }

  function productAddedFromCartAdd(json) {
    var items = lineItemsFromAddResponse(json);
    rememberItems(items);
    items.forEach(publishProductAdded);
    prefetchCart();
  }

  function checkoutPayload(cart) {
    var currency = (cart && cart.currency) || currencyCode();
    var totalCents = cart && cart.total_price != null ? cart.total_price : 0;
    var amount = dollars(totalCents);
    var items = (cart && cart.items) || lastItems || [];
    return {
      checkout: {
        token: (cart && (cart.token || cart.cart_token)) || cartToken(),
        currencyCode: currency,
        totalPrice: { amount: amount, currencyCode: currency },
        subtotalPrice: {
          amount: dollars(
            cart && cart.items_subtotal_price != null ? cart.items_subtotal_price : totalCents
          ),
          currencyCode: currency,
        },
        lineItems: items.map(function (item) {
          var variantId = variantIdOf(item);
          var productId = productIdOf(item);
          var lineAmount = itemDollars(item);
          var title = item.product_title || item.title || '';
          return {
            quantity: item.quantity || 1,
            title: title,
            variant: {
              id: variantId,
              price: { amount: lineAmount, currencyCode: currency },
              product: {
                id: productId,
                title: title,
                vendor: item.vendor || '',
                type: item.product_type || null,
                url: item.url || null,
              },
              sku: item.sku || null,
              title: item.variant_title || '',
            },
          };
        }),
      },
    };
  }

  function publishCheckoutStarted(cart) {
    if (seen('ic:checkout')) return;
    rememberCart(cart);
    var payload = checkoutPayload(cart);
    var currency = payload.checkout.currencyCode;
    var amount = payload.checkout.totalPrice.amount;
    var itemCount =
      cart && cart.item_count != null ? cart.item_count : (payload.checkout.lineItems || []).length;

    publishStandard('checkout_started', payload);

    // WPM Trekkie map: "Started Order" → checkout_started. "Started Checkout" is not mapped.
    trekkieTrack('Started Order', {
      currency: currency,
      total: amount,
      itemCount: itemCount,
      cartToken: (cart && (cart.token || cart.cart_token)) || cartToken() || undefined,
    });

    fbqTrack(
      'InitiateCheckout',
      {
        value: amount,
        currency: currency,
        num_items: itemCount,
      },
      'fbq:ic'
    );
  }

  function prefetchCart() {
    fetch(cartUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) rememberCart(cart);
      })
      .catch(function () {});
  }

  function requestCheckoutStarted() {
    if (recent['ic:checkout'] && now() - recent['ic:checkout'] < DEDUPE_MS) return;
    // Publish synchronously so checkout navigation cannot cancel the event.
    publishCheckoutStarted(
      lastCart || { currency: currencyCode(), total_price: 0, items: lastItems }
    );
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = new URL(url, root.location.origin).pathname;
      return /^(?:\/[a-zA-Z]+(?:-[a-zA-Z]+)?)?\/+cart\/+add(?:\.js|\.json)?\/*$/.test(path);
    } catch (e) {
      return /\/cart\/add(?:\.js|\.json)?/.test(String(url));
    }
  }

  function wrapFetch() {
    if (typeof root.fetch !== 'function' || root.fetch.__goldnMetaFunnel) return;
    var original = root.fetch.bind(root);
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var pending = original(input, init);
      if (!isCartAddUrl(url)) return pending;
      pending.then(function (response) {
        if (!response || !response.ok) return;
        response
          .clone()
          .json()
          .then(productAddedFromCartAdd)
          .catch(function () {});
      });
      return pending;
    };
    wrapped.__goldnMetaFunnel = true;
    root.fetch = wrapped;
  }

  function wrapXhr() {
    var XHR = root.XMLHttpRequest;
    if (!XHR || !XHR.prototype || XHR.prototype.__goldnMetaFunnel) return;
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__goldnCartAddUrl = url;
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      if (isCartAddUrl(this.__goldnCartAddUrl)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            var json = this.response;
            if (typeof json === 'string') json = JSON.parse(json);
            else if (json && typeof json === 'object' && !(json.items || json.variant_id || json.id)) {
              if (this.responseText) json = JSON.parse(this.responseText);
            }
            productAddedFromCartAdd(json);
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
    XHR.prototype.__goldnMetaFunnel = true;
  }

  function isCheckoutControl(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute('name') === 'checkout') return true;
    if (node.classList && node.classList.contains('js-cart-checkout-button')) return true;
    var href = node.getAttribute && (node.getAttribute('href') || node.getAttribute('formaction') || '');
    if (/\/checkout(\/|$|\?)/i.test(href)) return true;
    return false;
  }

  function bindCheckout() {
    root.document.addEventListener(
      'click',
      function (event) {
        var path = event.composedPath ? event.composedPath() : [event.target];
        for (var i = 0; i < path.length; i++) {
          if (isCheckoutControl(path[i])) {
            requestCheckoutStarted();
            return;
          }
          if (path[i] && path[i].classList && path[i].classList.contains('shopify-payment-button')) {
            requestCheckoutStarted();
            return;
          }
        }
      },
      true
    );

    root.document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.elements) return;
        var submitter = event.submitter;
        if (isCheckoutControl(submitter)) {
          requestCheckoutStarted();
          return;
        }
        if (form.querySelector('[name="checkout"]') && (form.getAttribute('action') || '').indexOf('/cart') !== -1) {
          requestCheckoutStarted();
        }
      },
      true
    );

    prefetchCart();
  }

  installWpmHook();
  pollWpm();
  wrapFetch();
  wrapXhr();
  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', bindCheckout);
  } else {
    bindCheckout();
  }

  root.GoldNMetaFunnel = {
    productAdded: productAddedFromCartAdd,
    checkoutStarted: requestCheckoutStarted,
    debug: function () {
      return {
        compile: '20260914w3',
        standardPublishCaptured: typeof standardPublish === 'function',
        pendingStandard: pendingStandard.length,
        wpmPresent: !!root.webPixelsManager,
        wpmInitType:
          root.webPixelsManager && root.webPixelsManager.init
            ? typeof root.webPixelsManager.init
            : 'missing',
        shopifyAnalyticsPublish: !!(
          root.Shopify &&
          root.Shopify.analytics &&
          typeof root.Shopify.analytics.publish === 'function'
        ),
        fbqType: typeof root.fbq,
        fbqValidPixelIds: loadedFbqPixelIds(),
        datasetIdNotUsedAsPixelId: DATASET_ID,
        shopifyFbRowIdNotUsedAsPixelId: SHOPIFY_FB_ROW_ID,
        testEventCode: readTestEventCode() || null,
        debug: debugEnabled(),
        lastPublish: lastPublish,
        lastFbq: lastFbq,
        lastError: lastError,
      };
    },
  };
})(typeof window !== 'undefined' ? window : this);
